import { ID, LineItem, LineItemChanges, Lot, LotChanges } from 'types';
import { matchesNew } from './matchesNew';
import { mergeCustomColumnItems } from './emptyCustomColumnItem';

const isNewLineItem = (lineItem: LineItem | LineItemChanges): boolean => matchesNew(String(lineItem.id)) && !lineItem._destroy;

export const getNewLineItems = (lineItemChanges?: Record<ID, LineItemChanges>): LineItem[] => {
  const hasLotChanges = lineItemChanges && Object.keys(lineItemChanges)?.length;

  if (!hasLotChanges) return [];
  return Object.values(lineItemChanges)
    .filter(isNewLineItem)
    .map((lineItem: LineItemChanges): LineItem => {
      const customColumnItems = !lineItem.custom_column_items?.length ? [] : Object.values(lineItem.custom_column_items);
      const newLineItem: LineItem = { ...lineItem, custom_column_items: customColumnItems };
      newLineItem.custom_column_items = mergeCustomColumnItems(newLineItem, lineItemChanges);

      return newLineItem;
    });
};

export const mergeLineItems = (lot: Lot, lotChanges?: Record<ID, LotChanges>): LineItem[] => {
  const hasLotChanges = lotChanges && Object.keys(lotChanges)?.length;
  if (!hasLotChanges) return lot.line_items;

  const lineItems: LineItem[] = lot.line_items;
  const lineItemsChanges: Record<ID, LineItemChanges> = lotChanges[lot.id]?.line_items;
  const hasLineItemsChanges = lineItemsChanges && Object.keys(lineItemsChanges).length;
  const result: LineItem[] = [];

  if (hasLineItemsChanges) {
    if (lineItems?.length) {
      const changedLineItems = lineItems.map((lineItem: LineItem) => ({
        ...lineItem,
        ...lineItemsChanges[lineItem.id],
        custom_column_items: mergeCustomColumnItems(lineItem, lineItemsChanges),
      }));

      // Update existing lineItems with changes.
      changedLineItems.forEach((lineItem: LineItem) => {
        result.push(lineItem);
      });
    }
    const newLineItems = getNewLineItems(lineItemsChanges);

    // Add new lineItems.
    newLineItems.forEach((lineItem: LineItem) => {
      result.push(lineItem);
    });
  } else if (lineItems?.length) {
    lineItems.forEach((lineItem: LineItem) => {
      result.push(lineItem);
    });
  }

  return result.map((lineItem: LineItem) => ({
    ...lineItem,
    lot_id: lot.id,
  }));
};
